// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__1OU22","perdeu":"LoginForm_perdeu__1Lc_f","cadastro":"LoginForm_cadastro__3XhHw","subtitle":"LoginForm_subtitle__3cz1X"};